import { Header, GridColumn, Grid, GridRow, Button, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { usePortfolioContext } from '~/hooks';
import { usePermissions } from '~/requests/permissions/usePermissions';
import NotesForm from '~/components/form/NotesForm';
import SummaryDocumentButton from '~/components/SummaryDocumentButton';
import DealSpreadsheetButton from '~/components/DealSpreadsheetButton';
import GenerateCimButton from '~/components/GenerateCimButton';
import PortfolioChecklist from './PortfolioChecklist';
import PortfolioCompletionStates from './PortfolioCompletionStates';

export default function PortfolioSummary() {
  const { permissions } = usePermissions();
  const { portfolio, portfolioDisplayValues } = usePortfolioContext();

  const projectHasStorage = portfolioDisplayValues?.summary?.technologies?.hasStorage as boolean;

  return (
    <Grid stackable>
      <GridColumn width={8} mobile={16} tablet={12} computer={8}>

        <PortfolioCompletionStates />

        {permissions.isInvestor && <PortfolioChecklist />}

        <div className="card">
          <Header as='h2'>Overview</Header>
          <Grid className="portfolio-details-grid" stackable>
            {[
              permissions.hasPortfolioInvestorAccess && {
                label: 'Developer',
                value: portfolioDisplayValues?.summary?.developer,
              },
              permissions.hasPortfolioDeveloperAccess && portfolio?.investor && {
                label: 'Investor',
                value: portfolioDisplayValues?.summary?.investor,
              },
              {
                label: 'Total size - PV',
                value: portfolioDisplayValues?.summary?.technologies?.totalSizeMWdc,
              },
              projectHasStorage && {
                label: 'Total size - BESS',
                value: portfolioDisplayValues?.summary?.technologies?.storage,
              },
              {
                label: 'Project quantity',
                value: portfolioDisplayValues?.summary?.projectQuantity,
              },
              {
                label: 'Pricing goal',
                value: portfolio?.projects[0]?.developmentStage === 'OPERATING' ? 'Project acquisition' : portfolioDisplayValues?.summary?.pricingType,
              },
              {
                label: 'Description',
                value: portfolioDisplayValues?.summary?.description,
              },
              permissions.hasPortfolioDeveloperAccess && {
                label: 'Portfolio Notes',
                value: <NotesForm portfolio={portfolio} />,
              },
              !permissions.hasPortfolioDeveloperAccess && portfolio?.portfolioNotes && {
                label: 'Portfolio Notes',
                value: portfolio?.portfolioNotes,
              },
            ]
              .filter(Boolean)
              .map((item: any, idx: number) => (
                <GridRow key={idx}>
                  <GridColumn width={3} className="portfolio-label">
                    <span>{item.label}</span>
                  </GridColumn>
                  <GridColumn width={9} className="portfolio-value">
                    <span>{item.value}</span>
                  </GridColumn>
                </GridRow>
              ))}
          </Grid>
        </div>

      </GridColumn>
      <GridColumn width={4} mobile={16} tablet={12} computer={4}>
        {(permissions?.isInvestor || permissions?.isAdmin) && (
          <div id="key-downloads" className="card">
            <Header as='h2' style={{ marginBottom: '1rem' }}>Key Downloads</Header>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
              <SummaryDocumentButton />
              <DealSpreadsheetButton />
              {permissions?.canReadDataroom && (
                <Button as={Link} to='dataroom' className="outlined secondary" size="small">
                  <Icon name='folder open' />
                  Go to data room
                </Button>
              )}
            </div>
          </div>
        )}
        {permissions?.isAdmin && portfolio?.id && (
          <div className="card">
            <div style={{ display: 'block', backgroundColor: '#CC0000', padding: '4px 6px', borderRadius: '4px', color: 'white', textAlign: 'center', fontSize: '12px', fontWeight: 'bold', marginBottom: '12px' }}>Admin only</div>
            <Header as='h2' style={{ marginBottom: '1rem' }}>CIM Generator</Header>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '12px' }}>
              <GenerateCimButton dealType='portfolio' dealId={portfolio.parentId ?? portfolio.id} />
            </div>
          </div>
        )}
      </GridColumn>

    </Grid>
  );
}